if (!customElements.get('mo-shop-recommendations')) {
  customElements.define('mo-shop-recommendations', class extends HTMLElement {
    static select(candidates, saved, seriesReady) {
      const filters = saved && saved.version === 1 && Date.now() - saved.updatedAt < 12 * 60 * 60 * 1000 ? saved.filters : null;
      const scifi = ['no', 'yes'].includes(filters?.scifi) ? filters.scifi : 'any';
      const moods = Array.isArray(filters?.mood) ? filters.mood.filter(value => ['romance', 'suspense', 'mystery', 'christmas'].includes(value)) : [];
      const formats = Array.isArray(filters?.format) ? filters.format.filter(value => ['novella', 'standalone', 'series'].includes(value)) : [];
      const read = filters?.read === 'read' && (!formats.length || formats.includes('series'));
      return candidates.filter(candidate => {
        if (!candidate.workId) return true;
        if (candidate.volume === '2' && !seriesReady && !read) return false;
        if (candidate.volume === '1' && read) return false;
        if (scifi === 'no' && Number(candidate.scifi) !== 0) return false;
        if (scifi === 'yes' && !(Number(candidate.scifi) > 0)) return false;
        if (moods.length && !moods.some(mood => candidate.moods.includes(mood))) return false;
        if (formats.length && !formats.includes(candidate.format)) return false;
        return true;
      }).slice(0, 2);
    }

    connectedCallback() {
      this.update = this.update.bind(this);
      this.update();
      document.addEventListener('mo:preferences-changed', this.update);
      if (this.dataset.sectionId && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }
    }

    disconnectedCallback() {
      document.removeEventListener('mo:preferences-changed', this.update);
      this.unsubscribe?.();
      this.request?.abort();
    }

    async refresh() {
      this.hidden = true;
      this.request?.abort();
      this.request = new AbortController();
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      try {
        const response = await fetch(url, { signal: this.request.signal });
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = html.querySelector('mo-shop-recommendations.mo-product-suggestions');
        if (replacement && this.isConnected) this.replaceWith(replacement);
      } catch {}
    }

    update() {
      let saved;
      try { saved = JSON.parse(sessionStorage.getItem('mo-shop:preferences:' + (window.Shopify?.theme?.id || ''))); } catch {}
      const elements = [...this.querySelectorAll('[data-recommendation]')];
      const candidates = elements.map(element => ({ ...element.dataset, moods: (element.dataset.moods || '').split(/\s+/) }));
      const visible = this.constructor.select(candidates, saved, this.dataset.seriesReady === 'true');
      elements.forEach((element, index) => { element.hidden = !visible.includes(candidates[index]); });
      this.hidden = !visible.length;
    }
  });
}
